import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

let appTimezone = process.env.REACT_APP_APP_TIMEZONE || 'UTC';

export const setAppTimezone = (timezoneValue: string) => {
  if (timezoneValue) {
    appTimezone = timezoneValue;
  }
};

export const getAppTimezone = (): string => appTimezone;

const toUtc = (value?: Date | string | null) => {
  if (!value) return null;
  return dayjs.utc(value);
};

export const formatAppDate = (value?: Date | string | null): string => {
  const parsed = toUtc(value);
  if (!parsed?.isValid()) return '-';
  return parsed.tz(getAppTimezone()).format('YYYY-MM-DD');
};

export const formatAppDateTime = (value?: Date | string | null): string => {
  const parsed = toUtc(value);
  if (!parsed?.isValid()) return '-';
  const formatted = parsed.tz(getAppTimezone()).format('YYYY-MM-DD HH:mm');
  return getAppTimezone() === 'UTC' ? `${formatted} UTC` : formatted;
};

export const formatAppTime = (value?: Date | string | null): string => {
  const parsed = toUtc(value);
  if (!parsed?.isValid()) return '-';
  return parsed.tz(getAppTimezone()).format('HH:mm');
};
